import type { ReactNode } from 'react';

export const symbol_oven: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M674-720q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm-173 0q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm-173 0q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm-148 99v441h600v-441H180Zm238 150h125q13 0 21.5-8.5T573-501q0-13-8.5-21.5T543-531H418q-13 0-21.5 8.5T388-501q0 13 8.5 21.5T418-471ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm300-501Zm0 0Z"
		/>
	</svg>
);
